export const WEBGATE_DOMAIN = `https://generic.wg.spotify.com`;
export const WEBAPI_DOMAIN = 'https://api.spotify.com';

// client ids
export const CLIENT_ID_S4A_ONBOARDING = '6491562e26a74a4dae998b7dbaf6983f';
export const CLIENT_ID_S4A_WEB = '6cf79a93be894c2086b8cbf737e0796b';

// webgate endpoints
export const DATA_API = `${WEBGATE_DOMAIN}/artistinsights`;
export const MANAGEMENT_API = `${WEBGATE_DOMAIN}/s4a-service`;
export const S4X_DATA_API = `${WEBGATE_DOMAIN}/s4x-insights-api`;
export const IDENTITY_API = `${WEBGATE_DOMAIN}/artist-identity-view`;
export const CONCERTS_API = `${WEBGATE_DOMAIN}/sponcerts`;
export const ONBOARDING_API = `${WEBGATE_DOMAIN}/s4a-onboarding`;
export const TOKEN_API = `${WEBGATE_DOMAIN}/creator-auth-proxy`;
export const PRERELEASE_API = `${WEBGATE_DOMAIN}/s4a-prerelease`;
export const SUBMISSION_API = `${WEBGATE_DOMAIN}/nms-submission`;
export const SUBMISSION_FORM_API = `${WEBGATE_DOMAIN}/nms-form-data`;
export const HOME_API = `${WEBGATE_DOMAIN}/s4x-home-service`;
export const LOGGER_API = `${WEBGATE_DOMAIN}/creator-logger`;
export const MARKETPLACE_MGMT_API = `${WEBGATE_DOMAIN}/marketplace-mgmt`;
export const WALLET_API = `${WEBGATE_DOMAIN}/s4x-wallet`;
export const ACTIVITY_API = `${WEBGATE_DOMAIN}/activity-feed`;

// webgate labs endpoints
export const LABS_API = `${WEBGATE_DOMAIN}/labs-service`;
export const XRAY_LAB_API = `${WEBGATE_DOMAIN}/creatorhack/xray`;
export const COLLAB_LAB_API = `${WEBGATE_DOMAIN}/artistinsights-neo4j-service`;
export const TRENDS_LAB_API = `${WEBGATE_DOMAIN}/best-trends`;

// external domains
export const IDENTITY_IMAGE_UPLOAD_API =
  'https://artist-identity-image.spotify.com';
export const CSV_DOWNLOAD_API = 'https://artistinsights-downloads.spotify.com';

// websocket endpoints
export const REALTIME_SOCKET_V3 =
  'wss://artistinsights-realtime3.spotify.com/ws';
